import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchCustomerContract } from '@/features/customer-contracts/api'

import { customerContractParamsSchema } from '../-models'

// 請求契約詳細
export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/customer-contracts/$customerContractId'
)({
  parseParams: (params) => parse(customerContractParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, customerContractId },
    context: { auth }
  }) => {
    const customerContract = await fetchCustomerContract(
      { tenantKey, customerContractId },
      abortController.signal
    )

    return {
      authUser: auth.user,
      customerContract
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.customerContract.name
    }
  ]
})
